/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsBasicModelResponse
 */
export interface RevisdomAPIViewModelsBasicModelResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsBasicModelResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsBasicModelResponse
     */
    name?: string | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsBasicModelResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsBasicModelResponse(value: object): value is RevisdomAPIViewModelsBasicModelResponse {
    return true;
}

export function RevisdomAPIViewModelsBasicModelResponseFromJSON(json: any): RevisdomAPIViewModelsBasicModelResponse {
    return RevisdomAPIViewModelsBasicModelResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsBasicModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsBasicModelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function RevisdomAPIViewModelsBasicModelResponseToJSON(json: any): RevisdomAPIViewModelsBasicModelResponse {
    return RevisdomAPIViewModelsBasicModelResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsBasicModelResponseToJSONTyped(value?: RevisdomAPIViewModelsBasicModelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

